import classNames from 'classnames';
import { type FC } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { type Tailwind } from 'styles/tw';

type Props = {
  mobileImageUrl: string;
  desktopImageUrl: string;
  height: Tailwind['height'];
  mobileAspectRatio: Tailwind['aspectRatio'];
  mobileBackgroundSize: Tailwind['backgroundSize'];
  desktopAspectRatio: Tailwind['aspectRatio'];
  scrollButtonImage?: {
    mobileImageUrl: string;
    desktopImageUrl: string;
    mobileWidth: number;
    desktopWidth: number;
    mobileHeight: number;
    desktopHeight: number;
  };
};

export const Hero: FC<Props> = ({
  mobileImageUrl,
  desktopImageUrl,
  height,
  mobileAspectRatio,
  mobileBackgroundSize,
  desktopAspectRatio,
  scrollButtonImage
}) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const element = document.getElementById('period-title');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <section>
      <div
        className={`${height} ${mobileAspectRatio} ${mobileBackgroundSize} semiLg:hidden bg-no-repeat relative`}
        style={{ backgroundImage: `url(${mobileImageUrl})` }}
      >
        {scrollButtonImage && (
          <a
            className={classNames(
              'w-full flex justify-center items-center absolute bottom-20 hover:opacity-70 duration-200 transition-opacity'
            )}
            onClick={(event) => handleClick(event)}
            role="button"
            aria-label="Scroll to period title"
          >
            <NextImage
              src={scrollButtonImage.mobileImageUrl}
              alt=""
              width={scrollButtonImage.mobileWidth}
              height={scrollButtonImage.mobileHeight}
            />
          </a>
        )}
      </div>
      <div
        className={`${height} ${desktopAspectRatio} bg-cover hidden semiLg:block bg-no-repeat relative`}
        style={{ backgroundImage: `url(${desktopImageUrl})` }}
      >
        {scrollButtonImage && (
          <a
            className={classNames(
              'w-full flex justify-center items-center absolute bottom-16 cursor-pointer hover:opacity-70 duration-200 transition-opacity'
            )}
            onClick={(event) => handleClick(event)}
            role="button"
            aria-label="Scroll to period title"
          >
            <NextImage
              src={scrollButtonImage.desktopImageUrl}
              alt=""
              width={scrollButtonImage.desktopWidth}
              height={scrollButtonImage.desktopHeight}
            />
          </a>
        )}
      </div>
    </section>
  );
};
